import { useEffect } from "react";
import { HiHome } from "react-icons/hi";
import { RiUserFollowLine } from "react-icons/ri";
import styled, { css } from "styled-components";
import tw, { theme } from "twin.macro";
import { apiRoutes } from "../../api";
import { useScreen } from "../../App";
import browserRoutes from "../../common/browserRoutes";
import { IPage } from "../../common/types";
import NavigateButtons from "./components/NavigateButtons";
import Posts from "./components/Posts";
import Topics from "./components/Topics";

export interface IndexPage extends IPage {
  pageType: pageTypes
}

export type pageTypes = 'home' | 'subscribed'

export const pages: IndexPage[] = [
  {
    title: "For You",
    pageType: 'home',
    icon: HiHome,
    apiRoute: apiRoutes.getPosts,
    location: browserRoutes.index,
  },
  {
    title: "Subscribed",
    pageType: 'subscribed',
    icon: RiUserFollowLine,
    apiRoute: apiRoutes.getSubscribePosts,
    location: browserRoutes.subscribe,
  },
];

export const findTemplate = (templatesObj: any, targetScreen: string) => {
  const screens = Object.keys(theme("screens")).reverse();
  const templs = Object.entries(templatesObj);

  let target;
  let targetIndex = templs.findIndex(([key, val]) => key == targetScreen);
  if (targetIndex != -1) {
    return templs[targetIndex][1];
  } else {
    const screensTargetIndex = screens.findIndex(
      (screen) => screen == targetScreen
    );
    target = screens.slice(screensTargetIndex).find((el) => {
      const t = templatesObj[el];
      if (t) {
        return t;
      }
    });
  }
  return templatesObj[target] ?? templatesObj["default"];
};

const indexTemplates = {
  default: css`
    grid-template:
      "topics topics"
      "navBtns posts" 1fr
      / auto 1fr;
  `,
  md: css`
    grid-template:
      "navBtns posts" auto
      "topics posts" 1fr
      / 1fr 3fr;
  `,
};

const Index = () => {
  const screen = useScreen();

  return (
    <Wrapper template={findTemplate(indexTemplates, screen)}>
      <NavigateButtons />
      <Topics />
      <Posts />
    </Wrapper>
  );
};

const Wrapper = styled.div(({ template }: { template: any }) => [
  tw`h-[var(--content-h)] py-1`,
  template,
  css`
    display: grid;
    gap: 0.3rem;

    ${Posts} {
      grid-area: posts;
    }
    ${NavigateButtons} {
      grid-area: navBtns;
    }
    ${Topics} {
      grid-area: topics;
    }
  `,
]);

export default Index;
